import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
  configure,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";
import PageLoading from "@/components/UI/PageLoading.vue";
import ComponentLoading from "@/components/UI/ComponentLoading.vue";
import { setToasts, setWarningToast } from "@/toasted/config.js";

import PrettyCheckbox from "pretty-checkbox-vue";
import StarRating from "vue-star-rating";

//custom toast messages
setToasts();
setWarningToast();

// install rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
    dirty: ["is-dirty", "is-dirty"],
  },
});

localize("en", en);

// Install components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(PrettyCheckbox);
Vue.component("star-rating", StarRating);

Vue.component("PageLoading", PageLoading);
Vue.component("ComponentLoading", ComponentLoading);

import "./assets/css/tailwind.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
